import React from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import CaseSummary from "../components/CaseSummary";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CaseSummaryDialog = ({ open, onClose, title, summary }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  if (!open) return null;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "800px",
          height: { xs: "100%", sm: "auto" },
          maxHeight: { xs: "100%", sm: "90vh" },
          m: 0,
          borderRadius: { xs: 0, sm: "24px" },
          boxShadow: "0 8px 32px 0 rgba(60, 80, 177, 0.13)",
          background: "linear-gradient(135deg, #fff 80%, #f8fafc 100%)",
        },
      }}
      BackdropProps={{
        sx: {
          background: "rgba(30,41,59,0.25)",
          backdropFilter: "blur(2px)",
        },
      }}
      fullScreen={isMobile}
    >
      <CaseSummary closeOnBack={onClose} title={title} summary={summary} />
    </Dialog>
  );
};

export default CaseSummaryDialog;
